import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import AboutSection from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import ContactSection from "../../components/ContactSection/ContactSection";
import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import useSmoothScroll from "../../components/SmoothScroll/useSmoothScroll";

const HomePage: React.FC = () => {
  useSmoothScroll();

  useEffect(() => {
    document.title = "Home | AI Agency & Technology";
  }, []);

  return (
    <Fragment>
      <div className="ai-agency">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HeroSection />
            <AboutSection />
            <ServiceSection />
            <ContactSection />
            <FeatureSection />
            <ProjectSection />
            <IndustriesMarqueeSection />
            <IndustriesSection />
            {/* <TestimonialSection /> */}
            <BlogSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HomePage;
